import { getInitials } from './getInitials';

export const getFirstLastLetter = (name: string, surname: string): string => {
  return getInitials(name)[0] + getInitials(surname)[0];
};
